import { render, staticRenderFns } from "./orderNotice.vue?vue&type=template&id=1613c9d1&scoped=true&"
import script from "./orderNotice.vue?vue&type=script&lang=js&"
export * from "./orderNotice.vue?vue&type=script&lang=js&"
import style0 from "./orderNotice.vue?vue&type=style&index=0&id=1613c9d1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1613c9d1",
  null
  
)

export default component.exports